import { value } from "devexpress-dashboard/model/index.metadata";

const status = [
    { key: "A", value: "Allow All Receipts Shipments" },
    { key: "N", value: "Receipts/Shipments Not Allowed" },
    { key: "R", value: "Allow Receipts Only" },
    { key: "S", value: "Allow Shipments Only" }
];
const LotStatus =[{ key: 'A', value: "Active" }, { key: 'I', value: "Inactive" }, { key: 'D', value: "Delete" }]
const TransactionStatuses = [{ key: 'O', value: 'Open' }, { key: 'H', value: 'Hold' }, { key: 'R', value: 'Ready To Commit Later' }];
const locationTypes = [
    { key: "D", value: "Dock Door" },
    { key: "F", value: "Forward Pick" },
    { key: "L", value: "Staging Location" },
    { key: "P", value: "Production Location" },
    { key: "S", value: "Storage Location" },
    { key: "Y", value: "Yard" }
];
const optionsYesNo = [{ key: "Y", value: "Yes" }, { key: "N", value: "No" }];
const TaskType = [
    { key: 1, value: "Send E-mail" },
    { key: 2, value: "Send Fax" },
    { key: 3, value: "Write To Windows Event Log" },
    { key: 4, value: "Write To Alert Log" },
    { key: 5, value: "Run ABECAS Insight Report/Program" },
    { key: 6, value: "Run Crystal Report" },
    { key: 7, value: "Run Program" },
    { key: 8, value: "Execute SQL Script" },
    { key: 9, value: "Import Data" },
    { key: 10, value: "Generate Export Data" },
    { key: 11, value: "Transfer Export Data" },
    { key: 12, value: "Process TaskAgent Job" },
    { key: 13, value: "Scheduale TaskAgent Job" },
    { key: 14, value: "Send FTP" },
    { key: 15, value: "Receive FTP" },
    { key: 16, value: "Receive POP3 E-mail" },
    { key: 17, value: "Maintenance Cleanup" },
]
const TaskState = [
    { key: "E", value: "Expired", icon: "clock" },
    { key: "F", value: "Failed", icon: "close" },
    { key: "P", value: "Processing", icon: "refresh" },
    { key: "S", value: "Successfully Processed", icon: "check" },
    { key: "U", value: "Unknown", icon: "help" },
    { key: "W", value: "Waiting to be Processed", icon: "info" },
];
const CommissionBases = [{ key: 'A', value: "Percent" }, { key: 'U', value: "Per Unit" }, { key: 'F', value: "Flat" }
    , { key: 'L', value: "Last Cost at Time Of OM Entry" }, { key: 'V', value: "Average Cost at Time of OM Entry" }, { key: 'S', value: "Standard Cost at Time of OM Entry" }, { key: 'I', value: "Calculate Based on Item" }
]
const TradeDisc = [
    { key: 'Y', value: "Yes, Apply Custom Discount" },
    { key: 'N', value: "No" }
];

const CostBasisMethodFlag = [
    { key: 'S', value: "Standard Cost" },
    { key: 'A', value: "Average Cost" },
    { key: 'L', value: "Last Cost" }
];

const RoundingMethod = [
    { key: 'A', value: "Round Up To Factor" },
    { key: 'B', value: "Round Down To Factor" },
    { key: 'C', value: "Round To Nearest Factor" },
    { key: 'N', value: "Round Up To #" },
    { key: 'E', value: "Round Down To #" },
    { key: 'F', value: "Round To Nearest #" }
];

const PriceSource = [
    { key: 'S', value: "Single Price" },
    { key: 'P', value: "Price Code" },
    { key: 'I', value: "Item Master" }
];

const PriceMethod = [
    { key: 'D', value: "Direct Price" },
    { key: 'B', value: "Basis Price" },
    { key: 'S', value: "Standard Cost" },
    { key: 'A', value: "Average Cost" },
    { key: 'L', value: "Last Cost" }
];

const CalcMethod = [
    { key: 'M', value: "% Markup" },
    { key: 'G', value: "Gross Margin" },
    { key: 'F', value: "Fixed Markup" }
];
    const PriceLevelColumns = [
        {key:"A", dataType: "string", dataField: "PriceLevelA", caption: "Price Level - A" },
        {key:"B", dataType: "string", dataField: "PriceLevelB", caption: "Price Level - B" },
        {key:"C", dataType: "string", dataField: "PriceLevelC", caption: "Price Level - C" },
        {key:"D", dataType: "string", dataField: "PriceLevelD", caption: "Price Level - D" },
        {key:"E", dataType: "string", dataField: "PriceLevelE", caption: "Price Level - E" },
        {key:"F", dataType: "string", dataField: "PriceLevelF", caption: "Price Level - F" },
        {key:"G", dataType: "string", dataField: "PriceLevelG", caption: "Price Level - G" },
        {key:"H", dataType: "string", dataField: "PriceLevelH", caption: "Price Level - H" },
        {key:"I", dataType: "string", dataField: "PriceLevelI", caption: "Price Level - I" },
        {key:"J", dataType: "string", dataField: "PriceLevelJ", caption: "Price Level - J" },
        {key:"K", dataType: "string", dataField: "PriceLevelK", caption: "Price Level - K" },
        {key:"L", dataType: "string", dataField: "PriceLevelL", caption: "Price Level - L" },
        {key:"M", dataType: "string", dataField: "PriceLevelM", caption: "Price Level - M" },
        {key:"N", dataType: "string", dataField: "PriceLevelN", caption: "Price Level - N" },
        {key:"O", dataType: "string", dataField: "PriceLevelO", caption: "Price Level - O" },
        {key:"P", dataType: "string", dataField: "PriceLevelP", caption: "Price Level - P" },
        {key:"Q", dataType: "string", dataField: "PriceLevelQ", caption: "Price Level - Q" },
        {key:"R", dataType: "string", dataField: "PriceLevelR", caption: "Price Level - R" },
        {key:"S", dataType: "string", dataField: "PriceLevelS", caption: "Price Level - S" },
        {key:"T", dataType: "string", dataField: "PriceLevelT", caption: "Price Level - T" },
        {key:"U", dataType: "string", dataField: "PriceLevelU", caption: "Price Level - U" },
        {key:"V", dataType: "string", dataField: "PriceLevelV", caption: "Price Level - V" },
        {key:"W", dataType: "string", dataField: "PriceLevelW", caption: "Price Level - W" },
        {key:"X", dataType: "string", dataField: "PriceLevelX", caption: "Price Level - X" },
        {key:"Y", dataType: "string", dataField: "PriceLevelY", caption: "Price Level - Y" },
        {key:"Z", dataType: "string", dataField: "PriceLevelZ", caption: "Price Level - Z" }
    ];
   const InventoryQuantitySource= [{ key: 'I', value: "Item" }, { key: 'L', value: "Lot" }, { key: 'S', value: "Sublot" }];
   const WeightBasisFlag= [{ key: 'I', value: "Item" }, { key: 'L', value: "Lot" }, { key: 'S', value: "Sublot" }, { key: 'U', value: "Unit" }];
   const ReceiptUomDefault= [{ key: 'I', value: "Inventory Unit" }, { key: 'P', value: "Pieces" }, { key: 'P', value: "Packages (eg. Pallets)" }, { key: 'H', value: "Shipment (eg. Container)" }];
   const RfReceiptValidation= [{ key: 'Y', value: "EDI import to insert Serial # records for valdation by RF program" }, { key: 'N', value: "EDI import to gonre Serial # records or Serial #s do not exist" }];
   const RfShipmentValidation= [{ key: 'Y', value: "EDI import to insert Serial # records for valdation by RF program" }, { key: 'N', value: "EDI import to gonre Serial # records or Serial #s do not exist" }];
   const ItemSourceFlag=[{ key: 'M', value: 'Manufactured' }, { key: 'P', value: 'Purchased' }, { key: 'O', value: 'Manufactured & Ordered' }, { key: 'R', value: 'Purchased & Ordered' }, { key: 'B', value: 'Brokered' }, { key: 'D', value: 'Drop-Ship' }];
   const ItemTypeFlag=[{ key: 'I', value: 'Item' }, { key: 'L', value: 'Item/Lot' }, { key: 'S', value: 'Item/Lot/Sublot' }, { key: 'U', value: 'Item/Lot/Sublot/Unit' }];
   const TaxStatus= [{ key: 'Y', value: "Yes" }, { key: 'N', value: "No" }, { key: 'A', value: "Always Taxable" }];
   const ReorderMethodFlag= [{ key: 'N', value: "Not Applicable" }, { key: 'M', value: "Based on Minimum-Maximum Quantity" }, { key: 'P', value: "Based on Minimum with Preset Order Quantity" }];
   const TaskQueueType = [{ key: 1, value: 'All' },{ key: 2, value: 'Task Queue Live' }, { key: 3, value: 'Task Queue History' }]
   const CreditReview = [
    { key: 'N', value: "Not Required" },
    { key: 'R', value: "Review Required" },
    { key: 'A', value: "Review Approved" }
];
const ChargeHoldType = [{ key: "A", value: "Not Applicabale" }];
const OrderSigned = [{ key: "Y", value: "Yes" },{ key: "N", value: "No" },{ key: "H", value: "No - Order Must be Signed to Print Pcking Slip or Change Stage to 'Picked' ord 'Completed' " }];
const CommissionType = [{ key: "N", value: "No Commissions" },{ key: "H", value: "By Transaction Header Only" }, { key: "D", value: "By Transaction Detail Only" },{ key: "B", value: "By Both Transaction Header & Detail" }
    ,{ key: "A", value: "Calculate When cash is received" }];

 const TransactionTypes = 
    [{ key:"R", value:"Receipt" },
    { key:"S", value:"Shipment" },
    { key:"A", value:"Adjustment" }]
export { status, locationTypes, optionsYesNo, TaskType, TaskState,TaskQueueType,LotStatus,
    CommissionBases,
    TradeDisc,
    CostBasisMethodFlag,
    RoundingMethod,
    PriceSource,
    PriceMethod,
    CalcMethod,
    InventoryQuantitySource,
    WeightBasisFlag,
    ReceiptUomDefault,
    RfReceiptValidation,
    RfShipmentValidation,
    ItemSourceFlag,
    ItemTypeFlag,
    TaxStatus,
    ReorderMethodFlag,
    CreditReview,
    ChargeHoldType,
    OrderSigned,
    CommissionType,
    TransactionStatuses,
    PriceLevelColumns,
    TransactionTypes
};